import React from 'react';
import { IconProps } from './IconProps';

const ChefHatIcon: React.FC<IconProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 2a5 5 0 0 1 5 5v1.5a1.5 1.5 0 0 0 3 0V7a5 5 0 0 1-5-5Z" />
    <path d="M12 2a5 5 0 0 0-5 5v1.5a1.5 1.5 0 0 1-3 0V7a5 5 0 0 0 5-5Z" />
    <path d="M20 15.5a2.5 2.5 0 0 1-5 0" />
    <path d="M15 15.5a2.5 2.5 0 0 0-5 0" />
    <path d="M9 15.5a2.5 2.5 0 0 1-5 0" />
    <path d="M4 18h16a2 2 0 0 1 2 2v2H2v-2a2 2 0 0 1 2-2Z" />
  </svg>
);

export default ChefHatIcon;
